<template>
  <v-autocomplete
    :loading="isLoading"
    :items="items"
    label="Supplier"
    clearable
    item-text="name"
    item-value="id"
    v-model="model"
    :disabled="disabled"
    :rules="rules"
  >
    <template v-slot:item="{ item }">
      <v-list-item-content>
        <v-list-item-title v-text="item.name"></v-list-item-title>
      </v-list-item-content>
    </template>
    <template v-slot:no-data>
      <v-list-item>
        <v-list-item-title>
          Search for a
          <strong>Location</strong>
        </v-list-item-title>
      </v-list-item>
    </template>
  </v-autocomplete>
</template>

<script>
export default {
  data() {
    return {
      mandatoryRules: [v => !!v || "This fiels is mandatory"],
      message: null,
      search: null,
      isLoading: false,
      items: [],
      options: { itemsPerPage: 0, sortBy: ['name']},
    };
  },
  props: {
    value: {
      type: [Number, String],
    },
    warehouseId: {
      type: Number
    },
    disabled: {
      type: Boolean
    },
    rules: {
      type: Array,
      default: () => []
    }
  },
  computed:{
    model:{
      get(){
        return this.value;
      },
      set(value){
        this.$emit("input", value);
        this.$emit("locationSelected", this.items.find(i => i.id == value))
      }
    }
  },
  mounted: function() {
    this.getSuppliers();
  },
  methods: {
    getSuppliers() {
      this.isLoading = true;
      this.$store
        .dispatch("supplier/list", {
            pagination: this.options,
            filters: {
              name:this.search
            },
        })
        .then(({suppliers}) => {
          this.items = suppliers.data;
        })
        .finally(() => (this.isLoading = false));
    }
  }
};
</script>
